/** Resolves after ms milliseconds. */
export const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

/**
 * Calls fn, and again after 1s, then 2s, … while Sharetribe answers 429 (too many requests),
 * up to maxRetries calls in all. Any other error, or the last 429, is thrown.
 */
export const withRetryOn429 = async (fn, maxRetries = 3) => {
  for (let attempt = 0; attempt < maxRetries; attempt++) {
    try {
      return await fn();
    } catch (e) {
      const status = e?.status || e?.statusCode;
      if (status === 429 && attempt < maxRetries - 1) {
        await delay(Math.pow(2, attempt) * 1000);
      } else {
        throw e;
      }
    }
  }
};
